export default __webpack_public_path__ + "static/media/Honored Armbands of the Four Winds.43186357.jpg";